export default defineNuxtPlugin(() => {
  // No session handling on portals without guest login (TR-40171/TR-40169).
  if (!useGuestLoginEnabled()) {
    return
  }

  const { getSession } = useGuest()
  getSession()
})
